import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

import type { PublicationModel } from '@models/types'

interface NoEditionsNoticeProps {
  publication: PublicationModel,
}

const NoEditionsNotice = (props: NoEditionsNoticeProps) => {
  const { publication } = props

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        as: 'a',
        border: '1px solid',
        borderRadius: 5,
        paddingY: 'medium',
        marginBottom: 'medium',
      }}
      forceBottomBorder
      href={`mailto:support@realhub.com.au?subject=No Editions for ${publication.title}`}
    >
      <Box borderRight="1px solid" borderColor="lineColor" justifyContent="center" width="auto">
        <Box
          alignItems="center"
          backgroundColor="whiteGrey"
          borderRadius={5}
          color="blue"
          flexDirection="column"
          height={40}
          justifyContent="center"
          marginX="medium"
          width={36}
        >
          <FontAwesomeIcon icon={faQuestionCircle} />
        </Box>
      </Box>

      <Box flexDirection="column" justifyContent="center" marginLeft="medium">
        <Text fontSize="small">No Editions</Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          Please contact Support
        </Text>
      </Box>
    </ListItem>
  )
}

export default NoEditionsNotice
